// extracted by mini-css-extract-plugin
export default {"card":"orderbook_card__mv+5k","cardTitle":"orderbook_cardTitle__6pZ2O","sortingContainer":"orderbook_sortingContainer__G3xgY","lastTrade":"orderbook_lastTrade__j65i9"};